import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/Login';
import LoginNew from '../pages/LoginNew';
import Register from '../pages/Register';
import content_cont from '../pages/Content';
import DashboardLayout from "../pages/DashboardLayout.vue";
import Dashboard from './../pages/Dashboard';
import Report from './../pages/Report';
import Profile from "../pages/Profile";
import Users from "../pages/Users";
import Online_monitoring from "../pages/Online_monitoring";
import Transport_request from "../pages/Transport_request";
import Transport_tender from "../pages/Transport_tender";
import ActiveFlights from "../pages/ActiveFlights";
import CompletedFlights from "../pages/CompletedFlights";
import User_tender from "../pages/User_tender";
import User_messages from "../pages/User_messages";
import contactAs from "../pages/contakt_as";
import Front_office from "../pages/Front_office";
import recoveryPaasword from "../pages/recover-password";
import Traker from "../pages/Traker";
import Tender from "../pages/Tender";
import Front from "../pages/Front";
import store from '../store/index';

Vue.use(Router)





export default new Router({
    mode: 'history',
    routes: [
        {
            path: "/traker",
            name: "traker",
            component: Traker,
            meta: { title: 'Traker' },
        },
        {
            path: "/",
            name: "login",
            component: Front,
            meta: { title: 'Front Page' },
        },
        {
        path: "/",
        name: "dashboard-layout",
        redirect: { name: 'dashboard' },
        component: DashboardLayout,
        meta: { title: 'Dashboard' },
        children: [
           {
                path: "/",
                component: content_cont,
                children: [
                    // {
                    //     path: "/",
                    //     name: "login",
                    //     //component: LoginNew,
                    //     component: Login,
                    //     meta: { title: 'Login' },
                    // },
                    {
                        path: "register",
                        name: "register",
                        //component: LoginNew,
                        component: Register,
                        meta: { title: 'Register' },
                    },
                    {
                        path: "login",
                        name: "loginNew",
                        component: LoginNew,
                        meta: { title: 'LoginNew' },
                    },
                    {
                        path: "/recoveryPassword:uid?",
                        name: "recoveryPaasword",
                        component: recoveryPaasword,
                        meta: { title: 'recoveryPaasword' },
                    },
                    {
                        path: 'main',
                        name: 'dashboard',
                        component: Dashboard,
                        meta: { title: 'Dashboard' }
                    },
                    {
                        path: 'profile',
                        name: 'profile',
                        component: Profile,
                        meta: { title: 'Profile' }
                    },
                    {
                        path: 'users',
                        name: 'users',
                        component: Users,
                        meta: { title: 'Users' }
                    },                  
                    
                    {
                        path: 'report',
                        name: 'report',
                        component: Report,
                        meta: { title: 'Report' },
                    },
                    {
                        path: 'online_monitoring',
                        name: 'online_monitoring',
                        component: Online_monitoring,
                        meta: { title: 'Online_monitoring' }
                    },
                    {
                        path: 'front_office',
                        name: 'front_office',
                        component: Front_office,
                        meta: { title: 'front_office' }
                        },
                    {
                        path: 'transport_request',
                        name: 'transport_request',
                        component: Transport_request,
                        meta: { title: 'transport_request' }
                    },
                    {
                        path: 'transport_tender',
                        name: 'transport_tender',
                        component: Transport_tender,
                        meta: { title: 'transport_tender' }
                    },
                    {
                        path: 'tender/:id',
                        name: 'tender',
                        component: Tender,
                        meta: { title: 'tender' },
                        beforeEnter:(to, from, next) => {
                            if (to.query.key) {
                                store.commit('setGuidClient',to.query.guid);
                                store.commit('setUserToken',to.query.key);
                                store.commit('setGuidTender',to.params.id);                                
                                next()
                              }
                            
                            console.log(to)
                            
                        
                            // if (to.name !== 'auth' && !storeRouteParametr(to, from) ){
                            //   sessionStorage.setItem('redirectPath', to.path);                  
                            //   next({name: 'auth'})
                            // }
                            // else next()
                          }
                    },
                    {
                        path: 'user_tender',
                        name: 'user_tender',
                        component: User_tender,
                        meta: { title: 'user_tender' }
                    },
                    {
                        path: 'active_flights',
                        name: 'active_flights',
                        component: ActiveFlights,
                        meta: { title: 'ActiveFlights' }
                    },
                    {
                        path: 'contact-as',
                        name: 'contact_as',
                        component: contactAs,
                        meta: { title: 'contact as' }
                    },
                    {
                        path: 'completed_flights',
                        name: 'completed_flights',
                        component: CompletedFlights,
                        meta: { title: 'CompletedFlights' }
                    },
                    {
                        path: 'user_messages',
                        name: 'user_messages',
                        component: User_messages,
                        meta: { title: 'user_messages' }
                    },
                ]
            }
        ]
        }
       
    ],
    //linkActiveClass: "active",
})



// WEBPACK FOOTER //
// ./src/router/index.js